import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'dateDiff',
    pure: true
})
export class DateDifferencePipe implements PipeTransform {
    constructor(private translate: TranslateService) {}

    transform(startingDate: Date, endingDate: Date): any {
        var startDate = new Date(startingDate);
        if (!endingDate) {
            endingDate = new Date();
        }
        let endDate = new Date(endingDate);

        if (startDate > endDate) {
            var swap = startDate;
            startDate = endDate;
            endDate = swap;
        }
        const startYear = startDate.getFullYear();
        const february = (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0 ? 29 : 28;
        const daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        let yearDiff = endDate.getFullYear() - startYear;
        let monthDiff = endDate.getMonth() - startDate.getMonth();
        if (monthDiff < 0) {
            yearDiff--;
            monthDiff += 12;
        }
        let dayDiff = endDate.getDate() - startDate.getDate();
        if (dayDiff < 0) {
            if (monthDiff > 0) {
                monthDiff--;
            } else {
                yearDiff--;
                monthDiff = 11;
            }
        }

        dayDiff = Math.abs(startDate.getTime() - endDate.getTime()) / (1000 * 60 * 60 * 24);
        
        let hourDiff = Math.abs(startDate.getTime() - endDate.getTime()) / (1000 * 60 * 60);
        let minuteDiff = Math.abs(startDate.getTime() - endDate.getTime()) / (1000 * 60);
        let secondDiff = Math.abs(startDate.getTime() - endDate.getTime()) / (1000 * 60);

        let weekDiff = dayDiff / 7;

        if (yearDiff >= 1) {
            return (Math.floor(yearDiff) + ' ' + this.translate.instant(Math.floor(yearDiff) > 1 ? 'COMMON.YEARS' : 'COMMON.YEAR'));
        }
        if (monthDiff >= 1) {
            return (Math.floor(monthDiff) + ' ' + this.translate.instant(Math.floor(monthDiff) > 1 ? 'COMMON.MONTHS' : 'COMMON.MONTH'));
        }
        if (weekDiff >= 1) {
            return (Math.floor(weekDiff) + ' ' + this.translate.instant(Math.floor(weekDiff) > 1 ? 'COMMON.WEEKS' : 'COMMON.WEEK'));
        }
        if (dayDiff >= 1) {
            return (Math.floor(dayDiff) + ' ' + this.translate.instant(Math.floor(dayDiff) > 1 ? 'COMMON.DAYS' : 'COMMON.DAY'));
        }
        if (hourDiff >= 1) {
            return (Math.floor(hourDiff) + ' ' + this.translate.instant(Math.floor(hourDiff) > 1 ? 'COMMON.HOURS' : 'COMMON.HOUR'));
        }
        if (minuteDiff >= 1) {
            return (Math.floor(minuteDiff) + ' ' + this.translate.instant(Math.floor(minuteDiff) > 1 ? 'COMMON.MINUTES' : 'COMMON.MINUTE'));
        }
        if (secondDiff >= 1) {
            return (Math.floor(secondDiff) + ' ' + this.translate.instant(Math.floor(secondDiff) > 1 ? 'COMMON.SECONDS' : 'COMMON.SECOND'));
        } else {
            return this.translate.instant('COMMON.NOW');
        }

    }
}

@Pipe({
    name: 'shortDate',
    pure: true
})
export class ShortDatePipe implements PipeTransform {
    constructor(private translate: TranslateService) {}

    transform(startingDate: Date, endingDate: Date): any {
        var startDate = new Date(startingDate);
        if (!endingDate) {
            endingDate = new Date();
        }
        let endDate = new Date(endingDate);

        if (startDate > endDate) {
            var swap = startDate;
            startDate = endDate;
            endDate = swap;
        }
        const startYear = startDate.getFullYear();
        
        let dayDiff = (endDate.getTime() - startDate.getTime()) / (3600 * 24 * 1000);
        
        if (Math.abs(dayDiff) > 1) {
            return this.translate.instant('COMMON.FULL-DATE', {
                date: startDate.toLocaleDateString(undefined, {month: 'short', day: '2-digit'}), 
                time: startDate.toLocaleTimeString(undefined, {hour: '2-digit', hour12: false, minute:'2-digit'})
            });
        } else {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);

            if (yesterday.toDateString() == startDate.toDateString()) {
                return this.translate.instant('COMMON.FULL-YESTERDAY', {
                    time: startDate.toLocaleTimeString(undefined, {hour: '2-digit', hour12: false, minute:'2-digit'})
                });
            } else {
                return this.translate.instant('COMMON.FULL-TIME', {
                    time: startDate.toLocaleTimeString(undefined, {hour: '2-digit', hour12: false, minute:'2-digit'})
                });
            }
        }
    }
}

@Pipe({
    name: 'longDate',
    pure: true
})
export class LongDatePipe implements PipeTransform {
    constructor(private translate: TranslateService) {}

    transform(startingDate: Date, endingDate: Date): any {
        var startDate = new Date(startingDate);
        if (!endingDate) {
            endingDate = new Date();
        }
        let endDate = new Date(endingDate);

        if (startDate > endDate) {
            var swap = startDate;
            startDate = endDate;
            endDate = swap;
        }
        const startYear = startDate.getFullYear();
        
        let dayDiff = (endDate.getTime() - startDate.getTime()) / (3600 * 24 * 1000);
        
            return this.translate.instant('COMMON.FULL-DATE', {
                date: startDate.toLocaleDateString(undefined, {month: 'short', day: '2-digit', year: 'numeric'}), 
                time: startDate.toLocaleTimeString(undefined, {hour: '2-digit', hour12: false, minute:'2-digit'})
            });
    }
}
